import { Link } from "react-router-dom";
import { getMerchAsset } from "../../data/merchAssets";
import MerchProductVisual from "./MerchProductVisual";
import { cardStyle, sectionLabelStyle, statusBadgeStyle } from "./MerchStyles";

function MerchProductCard({ product }) {
  const backImage = getMerchAsset(product.galleryKey, "Faded Black", "back");
  const frontImage = getMerchAsset(product.galleryKey, "Faded Black", "front");
  const cardImage = product.mockupUrl || backImage || frontImage;
  const cardView = backImage || !frontImage ? "back" : "front";

  return (
    <article className="merch-product-card" style={cardStyle}>
      <div className="merch-card-art" style={{ overflow: "hidden" }}>
        <MerchProductVisual product={product} color="Faded Black" view={cardView} imageSrc={cardImage} compact />
      </div>
      <div style={{ padding: "24px", display: "flex", flexDirection: "column", flex: 1 }}>
        <p style={sectionLabelStyle}>{product.collectionNumber}</p>
        <h2 style={{ margin: "0 0 9px", fontSize: "clamp(23px, 2.5vw, 28px)", letterSpacing: "-.02em" }}>{product.name}</h2>
        <p style={{ margin: "0 0 20px", color: "#aaa", lineHeight: 1.5 }}>{product.descriptor}</p>
        <span style={{ ...statusBadgeStyle, alignSelf: "flex-start", marginBottom: "24px" }}>{product.orderStatus}</span>
        <Link className="merch-action" to={`/merch/product/${product.id}`} style={{ marginTop: "auto", color: "white", textDecoration: "none", fontWeight: 900, letterSpacing: ".2px" }}>View Product <span aria-hidden="true">→</span></Link>
      </div>
    </article>
  );
}

export default MerchProductCard;
